// extracted by mini-css-extract-plugin
export default {"container":"components-Loading-styles-module__container--j2N6d","image":"components-Loading-styles-module__image--kTRsO"};